module.exports = __webpack_public_path__ + "static/media/thirdareaproduct1.8cf6bafc.jpg";